import { useState, useMemo, useEffect } from 'react'
import { AudienceTableRowType } from '@/features/analytics/model/slices/audienceSlice'
import { useInviteLinksStore } from '../../model'

export const useSortedData = (data: AudienceTableRowType[]) => {
    const { sortConfigAudience, setSortConfigAudience } = useInviteLinksStore()

    const [sortConfig, setSortConfig] = useState(sortConfigAudience || null)

    useEffect(() => {
        setSortConfig(sortConfigAudience)
    }, [sortConfigAudience])

    const handleSort = (key: keyof AudienceTableRowType) => {
        let direction: 'asc' | 'desc' = 'asc'
        if (sortConfig?.key === key && sortConfig.direction === 'asc') {
            direction = 'desc'
        }
        const newConfig = { key, direction }
        setSortConfig(newConfig)
        setSortConfigAudience(newConfig)
    }

    const sortedData = useMemo(() => {
        const sorted = [...data]
        if (sortConfig !== null) {
            sorted.sort((a, b) => {
                const { key, direction } = sortConfig
                const aValue = a[key]
                const bValue = b[key]

                if (aValue === null || aValue === undefined) return 1
                if (bValue === null || bValue === undefined) return -1

                if (
                    key === 'subscriptionDate' ||
                    key === 'unsubscriptionDate'
                ) {
                    const aDate = new Date(aValue as string)
                    const bDate = new Date(bValue as string)
                    return direction === 'asc'
                        ? aDate.getTime() - bDate.getTime()
                        : bDate.getTime() - aDate.getTime()
                }

                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    return direction === 'asc'
                        ? aValue - bValue
                        : bValue - aValue
                }

                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    return direction === 'asc'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue)
                }

                return 0
            })
        }
        return sorted
    }, [data, sortConfig])

    return { sortedData, handleSort, sortConfig }
}
